// LocalStorage-Key des im Chat gewählten Modells (Single Source of Truth).
export const MODEL_KEY = "jarvis.chat.model";

// Versionsgesicherte Einmal-Migration (SIMO-AGENTGRAPH-UI-MODEL-DEFAULT-MIGRATION-1).
const MIGRATION_KEY = "jarvis.chat.model.migration";
const MIGRATION_VERSION = "default-switch-1";

// Alter persistierter Default (bare + prefixed). Wird auf "Automatisch" ("")
// migriert — historischer Ballast, keine bewusste Wahl. Andere Modelle (qwen*,
// coder, llama, "" selbst) bleiben unangetastet.
const OLD_DEFAULT_VALUES = ["gpt-oss:20b", "ollama:gpt-oss:20b"];

type SimpleStorage = Pick<Storage, "getItem" | "setItem">;

/**
 * Migriert Bestandsnutzer einmalig vom alten UI-Default-Modell `gpt-oss:20b`
 * auf "Automatisch" (`""`), damit der Default-Switch (langgraph) für sie genauso
 * wirkt wie für neue Nutzer. Bewusste Modellwahlen bleiben erhalten. Über einen
 * Version-Key idempotent: läuft pro Browser genau einmal, auch wenn der Nutzer
 * danach wieder bewusst `gpt-oss:20b` wählt.
 */
export function runModelDefaultMigration(storage: SimpleStorage): void {
  if (storage.getItem(MIGRATION_KEY) === MIGRATION_VERSION) return;
  const current = storage.getItem(MODEL_KEY);
  if (current !== null && OLD_DEFAULT_VALUES.includes(current)) {
    storage.setItem(MODEL_KEY, "");
  }
  storage.setItem(MIGRATION_KEY, MIGRATION_VERSION);
}
